import React             from 'react';
import PropTypes         from 'prop-types';
import Translations      from '../../../utils/Translations';
import Flux              from '../../../flux/Flux';
import AboutMePlate      from './AboutMePlate';
import AboutMeCharacter  from './AboutMeCharacter';
import Facts             from '../ActorProfileOverview/Facts';

const MyProfile = ({actorData}) =>  {

    const titleText = actorData.isCouple
        ? Translations.get('actor_profile.about_me-my_profile.couple')
        : Translations.get('actor_profile.about_me-my_profile.solo');
    const TitleComponent = actorData.isSeoABTest ? Flux.Constants.Headlines.h1 : Flux.Constants.Headlines.h2;
    const title = <TitleComponent className="context-box__title" dangerouslySetInnerHTML={{__html: titleText}} />;

    return (
        <section className="container-block -margin-bottom-lg">
            <div className="col-xs-12">
                <div className="context-box--actor-profile">
                    {title}
                    <div className="content-box__body">
                        <div className="about-me-my-profile-container">
                            <AboutMePlate
                                aboutCircleItems = {actorData.aboutCircleItems}
                                isCouple         = {actorData.isCouple}
                                isMale           = {actorData.isMale}
                            />
                            <div className='about-me-my-profile-bias'>
                                <Facts
                                    age          = {actorData.age}
                                    cupSizePlain = {actorData.cupSizePlain}
                                    distance     = {actorData.distance || null}
                                    isCouple     = {actorData.isCouple}
                                    isMale       = {actorData.isMale}
                                    manPenisSize = {actorData.manPenisSize}
                                    sexuality    = {actorData.sexuality}
                                    size         = {actorData.size}
                                    weight       = {actorData.weight}
                                />
                                {actorData.isCouple
                                    ? <Facts
                                        age              = {actorData.partner.age}
                                        cupSizePlain     = {actorData.partner.cupSizePlain}
                                        distance         = {actorData.distance || null}
                                        isAboutMyPartner = {true}
                                        isCouple         = {actorData.isCouple}
                                        isMale           = {actorData.partner.isMale}
                                        manPenisSize     = {actorData.partner.manPenisSize}
                                        sexuality        = {actorData.partner.sexuality}
                                        size             = {actorData.partner.size}
                                        weight           = {actorData.partner.weight}
                                    />
                                    : <AboutMeCharacter
                                        characteristics = {actorData.characteristics}
                                        isCouple        = {actorData.isCouple}
                                        isMale          = {actorData.isMale}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

MyProfile.propTypes = {
    actorData: PropTypes.object
};

export default MyProfile;
